import {axiosUtil} from "../../../utils/axios_util";

const languageApi = {
    //分页查询
    languagePage(data:powerSearchData) {
        return axiosUtil({
            url: '/talk_script/manage/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },

    //删除
    languageDelete(id: string) {
        return axiosUtil({
            url: `/talk_script/manage/delete/${id}`,
            method: 'POST',
        })
    },
    //新增
    languageAdd(data: any) {
        return axiosUtil({
            url: `/talk_script/manage/create`,
            method: 'POST',
            data
        })
    },
    //编辑
    languageUpdate(data: any) {
        return axiosUtil({
            url: `/talk_script/manage/update`,
            method: 'POST',
            data
        })
    },
    //获取临时上传地址
    fileUpload(data: any) {
        return axiosUtil({
            url: `/talk_script/manage/temporary_upload?fileName=${data.fileName}`,
            method: "POST",
            data,
        });
    },
    //获取临时下载地址
    fileDownload(data: any) {
        return axiosUtil({
            url: `/talk_script/manage/temporary_download?objectName=${data}`,
            method: "POST",
            data,
        });
    },
    //查看详情
    languageDetail(id: string) {
        return axiosUtil({
            url: `/talk_script/manage/view_detail/${id}`,
            method: 'POST',
        })
    },
    //编辑
    sceneList() {
        return axiosUtil({
            url: `/talk_script/manage/find_customer_scene_tree`,
            method: 'GET'
        })
    },

}

export default languageApi
